import { constSelector, useRecoilValue } from "recoil";
import { v4 as uuid4 } from "uuid";

const trackingId = localStorage.getItem("airlytics-id") ?? uuid4();
localStorage.setItem("airlytics-id", trackingId);

export const trackingIdState = constSelector<string>(trackingId);

export const useTrackingId = () => useRecoilValue(trackingIdState);
